import Dimensions from "../../constants/styles/dimensions";

const getDateOrder = state => state.preferences.dateOrder;
const getThousandsSeparator = state => state.preferences.thousandsSeparator;

const getSkin = state => state.preferences.skin.split(" ").join(""); // Temporarily converting "Aeon Blue" to "AeonBlue"
const getAutoBackupEnabled = state => state.preferences.autoBackupEnabled;
const getAutoBackupLocation = state => state.preferences.autoBackupLocation;

const getAutoCheckUpdates = state => state.preferences.autoCheckUpdates;
const getAutoDownloadUpdates = state => state.preferences.autoDownloadUpdates;

const getAutoCloseScrivener = state => state.preferences.autoCloseScrivener;

const getGlobalFontSize = state =>
  state.preferences.get("globalFontSize") ? state.preferences.get("globalFontSize") : Dimensions.GLOBAL_FONT_SIZE;

export default {
  getDateOrder,
  getThousandsSeparator,
  getSkin,
  getAutoBackupEnabled,
  getAutoBackupLocation,
  getAutoCheckUpdates,
  getAutoDownloadUpdates,
  getGlobalFontSize,
  getAutoCloseScrivener
};
